import React, { useContext } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import LanguageContext from "../helper/LanguageContext";
import MaterialIcon from "./MaterialIcon";

function isEmailAccountConnectionError(account) {
  return account?.status === "error" || account?.status === "auth_error";
}

function accountLabel(account) {
  return (account && (account.email || account.name)) || "";
}

/**
 * Warning shown in the messages feed and on the E-Mail tab when one or more
 * connected mailboxes can no longer sync (status error / auth_error).
 */
function EmailConnectionWarningBanner() {
  const { strings } = useContext(LanguageContext);
  const history = useHistory();
  const emailAccounts = useSelector((s) => s.emailAccounts) || [];
  const broken = emailAccounts.filter(isEmailAccountConnectionError);
  if (broken.length === 0) return null;

  const emails = broken.map(accountLabel).filter(Boolean);
  const message =
    emails.length === 1
      ? (strings.email_connection_warning ||
          "The email connection for {email} is not working properly. Reconnect to keep receiving new emails.").replace(
          "{email}",
          emails[0]
        )
      : emails.length > 1
        ? (strings.email_connection_warning_multi ||
            "Email connections for {emails} are not working properly. Reconnect to keep receiving new emails.").replace(
            "{emails}",
            emails.join(", ")
          )
        : strings.email_reconnect_banner ||
          "One or more email accounts need to be reconnected.";

  return (
    <div
      className="email-reconnect-banner"
      role="alert"
      data-testid="emailConnectionWarning"
    >
      <div className="email-reconnect-banner-accent" aria-hidden />
      <div className="email-reconnect-banner-icon" aria-hidden>
        <MaterialIcon icon="warning" size={22} color="#ffffff" fill={1} />
      </div>
      <div className="email-reconnect-banner-copy">
        <div className="email-reconnect-banner-title">
          {strings.email_connection_error || "Connection issue"}
        </div>
        <div className="email-reconnect-banner-text">{message}</div>
      </div>
      <button
        type="button"
        className="kj-btn kj-btn--primary kj-btn--danger kj-btn--sm email-reconnect-banner-action"
        onClick={() => history.push("/profile-setting", { openSection: "email-accounts" })}
      >
        {strings.email_reconnect_manage || "Fix in settings"}
      </button>
    </div>
  );
}

export default EmailConnectionWarningBanner;
